module.exports = __webpack_public_path__ + "img/tick-outline.7634aa55.svg";